import { Parallax, ParallaxProvider } from "react-scroll-parallax";
import Layout from "src/components/layout";
import NewsLetter from "src/components/newsletter";

export default function AboutUs() {
  return (
    <Layout>
      <div className="bgHeroBanner">
        <div className="grid grid-cols-[1fr_2fr] lg:flex lg:w-[100%] text-white py-10 px-[5%] mx-auto max-w-[1400px] gap-5">
          <div className="aboutUsImagesContainer lg:w-[30%] lg:max-w-[320px]">
            <img src={require("../../assets/pages/aboutUs1.png")} alt=""></img>
            <img src={require("../../assets/pages/aboutUs2.png")} alt=""></img>
            <img src={require("../../assets/pages/aboutUs3.png")} alt=""></img>
          </div>
          <div className="flex flex-col gap-5 lg:flex-row lg:w-[65%]">
            <h1 className="text-4xl font-bold">About MARDIIN</h1>
            <div>
              <p>
                Founded in 2009, MARDIIN specializes in developing and expanding world-class brands across Central America. By combining regional insight with strong international partnerships, we deliver exceptional products tailored to modern lifestyles.
              </p>
              <br></br>
              <p>
                Over the years, we have built significant market presence and earned industry recognition for our commitment to brand growth.
              </p>
              <br></br>
              <p>
                Operating as Premier Distributions across El Salvador, Honduras, Guatemala, Nicaragua, Panamá, Costa Rica, and Belize, our centralized approach enables us to scale rapidly and bring premium experiences to the region's most demanding consumers.
              </p>
            </div>
          </div>
        </div>
      </div>
      <ParallaxProvider>
        <div className="bg-white text-[#002138] py-10">
          <div className="ml-[37%] w-[60%] lg:flex lg:gap-4">
            <Parallax
              className="hidden lg:block"
              speed={-10}
              translateY={[-30, 60]}>
              <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
            </Parallax>
            <h2 className="text-2xl font-bold mb-4 block lg:hidden">
              Our Mission
            </h2>
            <p className="lg:mt-16">
              To deliver a curated portfolio of high-end products to Central America's most demanding consumers, building lasting partnerships with brand owners, distributors, and retailers.
            </p>
          </div>
          <div className="py-12 px-2 max-w-[1200px] lg:mx-auto flex overflow-x-scroll [&>img]:rounded-3xl [&>img]:w-[70%] [&>img]:max-h-[140px] gap-4 md:overflow-hidden md:[&>img]:rounded-none md:[&>img]:w-[30%] md:gap-[4%]">
            <img src={require("../../assets/pages/aboutUs4.png")} alt=""></img>
            <img src={require("../../assets/pages/aboutUs5.png")} alt=""></img>
            <img src={require("../../assets/pages/aboutUs6.png")} alt=""></img>
          </div>
          <div className="ml-[37%] w-[60%] lg:flex lg:gap-4">
            <Parallax
              className="hidden lg:block"
              speed={-12}
              translateY={[-30, 60]}>
              <h2 className="text-2xl font-bold mb-4">Our Vision</h2>
            </Parallax>
            <h2 className="text-2xl font-bold mb-4 block lg:hidden">
              Our Vision
            </h2>
            <p className="lg:mt-16">
              To be Central America’s premier brand-building network, setting the benchmark for distribution excellence, customer service, and market expansion.{" "}
            </p>{" "}
          </div>
        </div>
      </ParallaxProvider>
      <NewsLetter></NewsLetter>
    </Layout>
  );
}
